import { render } from "./ChurchDashboard.vue?vue&type=template&id=3589b964&scoped=true"
import script from "./ChurchDashboard.vue?vue&type=script&lang=js"
export * from "./ChurchDashboard.vue?vue&type=script&lang=js"

import "./ChurchDashboard.vue?vue&type=style&index=0&id=3589b964&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3589b964"]])

export default __exports__